import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges, OnDestroy, inject, Inject } from '@angular/core';
import MetisMenu from 'metismenujs';
import { EventService } from '../../../core/services/event.service';
import { Router, NavigationEnd, RouterModule } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { EchoService } from 'src/app/core/services/echo.service';
import { Subject } from 'rxjs';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { ClubManagementTableService } from 'src/app/modals/ClubManagement/club-management-table.service';
import { PermissionService } from 'src/app/core/services/permission.service';
import { APP_VERSION } from 'src/app/core/services/version.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone:true,
  imports:[SimplebarAngularModule,RouterModule,CommonModule,TranslateModule ]
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  data: any;
  env: string = environment.env;
  private destroy$ = new Subject<void>();
  menuItems: MenuItem[] = [];
  totalUnreadChats: number = 0;
  totalOpenTasks: number = 0;

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(
    private permissionService: PermissionService,
    private eventService: EventService, 
    private router: Router, 
    public translate: TranslateService, 
    private http: HttpClient,
    public echoService: EchoService,
    public localStorageService: LocalStorageService,
    public taskTableService: ClubManagementTableService,
    public localStorageSerivce: LocalStorageService,
    @Inject(APP_VERSION) public appVersion: string
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.echoService.echo.leave(`task.unread.contributie`);
    this.echoService.echo.leave(`agenda-task.open.contributie`);
  }

  ngOnInit() {
    this.initialize();
    this._scrollElement();

    this.echoService.joinTaskUnreadChannel((data) => {
      this.totalUnreadChats = data ? data.length : 0;
      //Call again only once previous was successful
    });

    this.echoService.joinOpenAgendaTaskChannel((data) => {
      this.totalOpenTasks = data ? data.length : 0;
    });

    this.echoService.fetchTaskCount();
    this.echoService.fetchOpenAgendaCount();

    setTimeout(() => {
      const totalTasks: string[] = this.localStorageSerivce.getItem("task-counter");
      if(totalTasks){
        this.totalUnreadChats = totalTasks.length;
      }

      const totalOpenTasks: string[] = this.localStorageSerivce.getItem("open-agenda-task");
      if(totalOpenTasks){
        this.totalOpenTasks = totalOpenTasks.length;
      }
      
    }, 2000)

  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event) {

    //THIS ACTION CLOSES ALL DROPDOWN IF THE ITEM IN SIDEBAR IS CLICKED WHICH IS NOT A DROPDOWN, IT AUTOMATICALLY WORKS IF THE 2nd ITEM IS ALSO DROPDOWN SO THIS ONE IS A SOLUTION FOR THE ONES THAT DONT CAUSE AUTO CLOSE
    // event.currentTarget.nextElementSibling.classList.toggle('mm-show');

    const currentToggle = event.currentTarget as HTMLElement;
    // Collapse all other open dropdowns

    //Inactive for active other items
    const allOtherItems = this.sideMenu.nativeElement.querySelectorAll('.mm-active');
    allOtherItems.forEach((clickitem: HTMLElement) => {
      if (!clickitem.contains(currentToggle.nextElementSibling)) {
        clickitem.classList.remove('mm-active');
        if (clickitem.classList.contains('mm-active')) {
          clickitem.classList.remove('mm-active');
        }
      }
    });

    //Inactive for all active dropdowns
    const allDropdowns = this.sideMenu.nativeElement.querySelectorAll('.mm-show');
    const parent = currentToggle.getAttribute("data-parent");
    allDropdowns.forEach((dropdown: HTMLElement) => {
      if(!parent || dropdown.getAttribute("id") != parent){ //It ensures that if the dropdown is the parent dropdown of the current link then dont close that dropdown 
        if (!dropdown.contains(currentToggle.nextElementSibling)) {
          dropdown.classList.remove('mm-show');
          const parent = dropdown.parentElement;
          if (parent && parent.classList.contains('mm-active')) {
            parent.classList.remove('mm-active');
          }
        }
      }
    });

    // Toggle current one
    const submenu = currentToggle.nextElementSibling;
    submenu?.classList.toggle('mm-show');
    const parentLi = currentToggle.closest('li');
    parentLi?.classList.toggle('mm-active');

  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {

    return;
    
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  isActive(route: string): boolean {
    return this.router.url.startsWith(route);
  }

}
